import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions, userActions } from "../../../_actions";
import Dashboard from "../Dashboard/Dashboard";
import Heading from "../../AdminPanel/Component/UI/Heading";
import SearchBox from "../../AdminPanel/Component/UI/SearchBox";
import StatsCard from "../../AdminPanel/Component/UI/StatsCard";
import CommonTableTeam from "../../AdminPanel/Component/UI/CommonTableTeam";
import Tooltip from "../../AdminPanel/Component/UI/Tooltip";
// import AddCampaignsModal from "./Component/AddCampaignsModal";
// import UpdateCampaignsModal from "./Component/UpdateCampaignsModal";
import { MdSearch, MdArrowForwardIos, MdOutlineArrowBack, MdArrowBackIos } from "react-icons/md";
import { LuUsers, LuUserCheck, LuDownload } from "react-icons/lu";
import { HiOutlineHome, HiMiniPlus } from "react-icons/hi2";
import { AiOutlineMail, AiOutlineFileText } from "react-icons/ai";
// import { AiOutlineUsergroupAdd } from "react-icons/ai";
// import { FiEdit } from "react-icons/fi";
// import { RiDeleteBinLine } from "react-icons/ri";
// import { TbUsersPlus } from "react-icons/tb";
import { SlReload } from "react-icons/sl";
// import { BsBarChartLine } from "react-icons/bs";
// import { LuAlarmClock } from "react-icons/lu";
import moment from 'moment';


class MyCampaignAnalytics extends Component {

  constructor(props) {
    super(props);
    this.state = {
      teamId: this.props.match.params.id,
      addCampaignsModal: false,
      updateUserModal: false,
      entries: 20,
      formData: {
        title: "",
        subject: "",
        message: "",
        teamId: "",
        assessment: "644abb4b1236ff3f408634d1",
        type: "team",
        list: [],
        stage: 1
      },
      pageNo: 1,
      size: 10,
      keyWord: "",

    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
    const tempX1 = {
      id: this.state.teamId
    }
    this.props.dispatch(assessmentActions.getCoachCampDetails(tempX1));


    const temp = {
      teamId: this.state.teamId,
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    this.props.dispatch(assessmentActions.getCoachCampUserList(temp));
    this.props.dispatch(assessmentActions.getCoachCampUserAnalytics({
      teamId: temp.teamId
    }));
    this.callUserListAPI();
  }

  handleInputChange = (e) => {
    let { formData } = this.state;
    let name = e.target.name;
    let value = e.target.value;
    if (name === "type" || name === "teamId") {
      formData[name] = value.value;
    } else {
      formData[name] = value;
    }
    this.setState({ formData })
  }

  openAddCampaignsModal = () => {
    console.log("Opening Add User Modal");
    this.setState({ addCampaignsModal: true }, () => {
      console.log("Modal state updated:", this.state.addCampaignsModal);
    });
  };

  closeAddCampaignsModal = (type) => {
    if (type === "prev") {
      let { formData } = this.state;
      this.setState({ formData: { ...formData, stage: 1 } });
    } else {
      console.log("Closing Add User Modal");
      this.setState({ addCampaignsModal: false });

    }
  };

  // Handle entries dropdown change
  handleEntriesChange = (value) => {
    this.setState({ entries: value });
  };

  // Open modal
  openUpdateCampaignsModal = () => {
    this.setState({ updateUserModal: true });
  };

  // Close modal
  closeUpdateCampaignsModal = () => {
    this.setState({ updateUserModal: false });
  };

  // Reupload handler
  handleReupload = () => {
    console.log("Reupload clicked");
    this.setState({ updateUserModal: false });
  };

  onSubmitForm = () => {
    let { formData } = this.state;
    const temp = {
      teamId: formData.teamId,
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    this.props.dispatch(assessmentActions.getMyUserList(temp));
    this.setState({ formData: { ...formData, stage: 2 } });
  }


  onSelectionChange = (value) => {
    console.log("list--------.--------.--->", value)
    let { formData } = this.state;
    this.setState({ formData: { ...formData, list: value } });
  }


  onSubmit = () => {
    let { formData } = this.state;
    const data = {
      title: formData?.title ?? "",
      subject: formData?.subject ?? "",
      message: formData?.message ?? "",
      list: formData?.list ?? [],
      productId: formData?.assessment ?? "",
      teamId: formData?.teamId ?? null,
      type: formData?.type ?? ""
    };
    const temp = {
      "keyWord": "",
      "pageNo": 1,
      "size": 10
    }
    this.props.dispatch(assessmentActions.saveCoachCampaign(data, temp));
    setTimeout(() => {
      this.setState({
        addCampaignsModal: false,
        formData: {
          title: "",
          subject: "",
          message: "",
          assessment: "",
          teamId: "",
          assessment: "talent28",
          type: "team",
          stage: 1
        }
      });
    }, 500)
  }

  goBack = () => {
    this.props.history.push(`/assessment/myteams`);
  }

  callUserListAPI = () => {
    const { pageNo, size, keyWord } = this.state;
    this.props.dispatch(
      assessmentActions.getTeamList({
        pageNo,
        size,
        keyWord
      })
    );
  };

  componentDidUpdate(prevProps, prevState) {
    // if (
    //   prevState.pageNo !== this.state.pageNo ||
    //   prevState.size !== this.state.size ||
    //   prevState.keyWord !== this.state.keyWord
    // ) {
    //   this.callUserListAPI();
    // }
  }

  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "teamId": this.state.teamId,
      "keyWord": value,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(assessmentActions.getCoachCampUserList(data));
  }

  handleSizeChange = (e) => {
    this.setState({
      size: Number(e.target.value),
      pageNo: 1
    });
  };

  goPrev = () => {
    this.setState((prev) => ({
      pageNo: Math.max(prev.pageNo - 1, 1)
    }));
  };

  goNext = () => {
    const { getCoachCampUserListTotal } = this.props.assessment;
    const totalPages = Math.ceil(getCoachCampUserListTotal / this.state.size);
    this.setState((prev) => ({
      pageNo: Math.min(prev.pageNo + 1, totalPages)
    }));
  };
  sendMail = (data) => {
    const tempX1 = {
      id: data.campUserId
    }
    this.props.dispatch(assessmentActions.sendCoachCampMail(tempX1));
  }

  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };
  switchToSelf = () => {
    this.props.dispatch(userActions.userCoachSwitchLogin({}, this.props));
  };

  viewReport = (row) => {
    if (row && row.code) {
      if (row.productCode === "FocusProfile") {
        this.props.history.push(`/assessment/focusprofilereport/admin/` + row.code);
      } else if (row.productCode === "EnergyProfile") {
        this.props.history.push(`/assessment/energyprofilereport/admin/` + row.code);
      } else if (row.productCode === "TalentPlusStrengths21") {
        this.props.history.push(`/assessment/mileprofilereport/admin/` + row.code);
      }
    }

  }



  render() {
    const { pageNo, size } = this.state;
    let { assessment } = this.props;
    let { getCoachCampDetailsData, userAssessmentUserProfileData, getCoachCampUserListData, getCoachCampUserListTotal, getCoachCampUserAnalyticsData, loading } = assessment;

    const campName = getCoachCampDetailsData?.title ?? "My Responses";


    const columns = [
      { key: "id", label: "S.No." },
      { key: "name", label: "User Name" },
      { key: "email", label: "User Email" },
      { key: "launchdate", label: "Launch Date" },
      { key: "status", label: "Status" },
    ];

    let data = getCoachCampUserListData && getCoachCampUserListData.length > 0 ?
      getCoachCampUserListData.map((ele, i) => ({
        id: i + 1,
        campUserId: ele.id,
        code: ele.code,
        userId: ele.userId.id,
        productCode: ele.productId.code,
        name: ele.userId.name,
        email: ele.userId.email,
        launchdate: moment(ele.createdAt).format("DD MMMM, YYYY hh:mm"),
        status: ele.isComplete ? "Completed" : (ele.isClicked ? "Pending" : "Not Started")
      })) : [];

    const rs = getCoachCampUserAnalyticsData?.[0] ?? {};
    const mailSent = Number(rs.mailSent) || 0;
    const clicked = Number(rs.clicked) || 0;
    const completed = Number(rs.completed) || 0;
    const responseObj = {
      mailSent,
      clicked,
      notclicked: Math.max(mailSent - clicked, 0),
      completed,
      notcompleted: Math.max(mailSent - completed, 0),
    };

    const statsList = [
      {
        icon: LuUsers,
        label: "Sent",
        value: responseObj.mailSent
      },
      {
        icon: LuUserCheck,
        label: "Clicked",
        value: responseObj.clicked
      },
      {
        icon: SlReload,
        label: "Not Clicked",
        value: responseObj.notclicked
      },
      {
        icon: LuUserCheck,
        label: "Completed",
        value: responseObj.completed
      },
      {
        icon: SlReload,
        label: "Not Completed",
        value: responseObj.notcompleted
      }
    ];

    const start = getCoachCampUserListTotal === 0 ? 0 : (pageNo - 1) * size + 1;
    const end = Math.min(pageNo * size, getCoachCampUserListTotal);
    const totalPages = Math.ceil(getCoachCampUserListTotal / size);

    const getPeriod = () => {
      const hour = moment().hour(); // 0–23

      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };
    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod()
    };


    return (
      <Dashboard userDetails={userDetails} logout={this.logout} switchToSelf={this.switchToSelf}>
        <div className="space-y-6 p-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="flex items-center space-x-3">
                <div className="bg-white hover:text-[#1976D2] textblack border border-[#D1D5DB] p-1.5 rounded-full cursor-pointer" onClick={() => this.goBack()}>
                  <MdOutlineArrowBack size={26} className="inline-block" />
                </div>
                <Heading className="text-xl" title={campName} />
              </div>
              <h2 className="text-lg font-semibold"></h2>
              <div className="h-6 w-[1px] bg-gray-300" />
              <span className="text-sm textblack flex items-center gap-2">
                <span className="textblack"><HiOutlineHome size={22} /></span>
                <span className="textblack"><MdArrowForwardIos size={16} /></span>
                <span className="textblack">My Responses List</span>
              </span>
            </div>

            {/* <div className="flex items-center gap-3">
              <AddButton title="Add New" Icon={HiMiniPlus} className="bgcolor text-white" onClick={this.openAddCampaignsModal} />
            </div> */}
          </div>

          {/* Stats Section*/}
          <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
            {statsList.map((item, index) => (
              <StatsCard
                key={index}
                icon={item.icon}
                label={item.label}
                value={item.value}
              />
            ))}
          </div>

          {/* Table Section*/}
          <div className="overflow-x-auto bg-white border rounded-md p-4">
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-2 text-sm textblack">
                Show
                <select value={this.state.size} onChange={this.handleSizeChange} className="border rounded-md px-2 py-1">
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                entries
              </div>
              <div className="flex items-center gap-3 text-sm textblack">
                <div className="">
                  <SearchBox
                    value={this.state.keyWord}
                    onChange={this.handleSearch}
                    placeholder="Search"
                  />
                </div>
                <div>{start}-{end} of {getCoachCampUserListTotal}</div>
                <div onClick={this.goPrev} disabled={this.state.pageNo === 1} className={`p-2 rounded-md ${this.state.pageNo === 1 ? "opacity-40 cursor-not-allowed" : "bglightcolor textcolor"}`}>
                  <MdArrowBackIos size={20} />
                </div>
                <div onClick={this.goNext} disabled={this.state.pageNo === totalPages} className={`p-2 rounded-md ${this.state.pageNo === totalPages ? "opacity-40 cursor-not-allowed" : "bglightcolor textcolor"}`}>
                  <MdArrowForwardIos size={20} />
                </div>
              </div>
            </div>
            <CommonTableTeam
              columns={columns}
              data={data}

              renderActions={(row) => (
                <div className="flex gap-2">
                  <Tooltip text="Send Email" position="top">
                    <div onClick={() => this.sendMail(row)} className="p-2 cursor-pointer rounded bg-gray-100 text-black hover:bg-gray-200"><AiOutlineMail size={18} /></div>
                  </Tooltip>
                </div>
              )}

              renderReports={(row) => (
                <div className="flex gap-2">
                  <Tooltip text="Show Report" position="top">
                    <div onClick={() => this.viewReport(row)} className="p-2 cursor-pointer rounded bg-gray-100 text-black hover:bg-gray-200"><AiOutlineFileText size={18} /></div>
                  </Tooltip>
                </div>
              )}

            />

            {!loading && !(data && data.length > 0) &&
              <div className="flex items-center justify-center">
                <div className="text-center py-8">
                  <div className="flex flex-col items-center justify-center text-gray-500">
                    <h1 className="text-lg font-semibold">No Data Found</h1>
                    <p className="text-sm mt-1">Try adjusting your search or filters</p>
                  </div>
                </div>
              </div>
            }



          </div>


        </div>

      </Dashboard>
    );
  }
}

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { assessment } = state;
  return {
    loggingIn,
    assessment
  };
}

export default connect(mapStateToProps)(MyCampaignAnalytics);

